import { FC, ReactNode } from "react";
import Spinner from "../../../public/images/spinner.svg";
import { Button } from "./Button";

type Props = {
  isSubmitting?: boolean;
  isLoading?: boolean;
  text: ReactNode;
  type: "button" | "submit" | "reset";
  className?: string;
  dataCy?: string;
  disabled?: boolean;
  onClick?: () => void;
};

const LoadingButton: FC<Props> = ({
  isLoading,
  isSubmitting,
  text,
  type,
  className,
  dataCy,
  disabled,
  ...rest
}) => {
  return (
    <Button
      disabled={isLoading || isSubmitting || disabled}
      type={type}
      dataCy={dataCy}
      className={className}
      {...rest}
    >
      {isLoading ? (
        <div className="flex items-center gap-2">
          <Spinner
            className="animate-spin max-w-[unset]"
            width={22}
            height={22}
            alt="spinner"
          />
          <span>{text}</span>
        </div>
      ) : (
        <span>{text}</span>
      )}
    </Button>
  );
};

export { LoadingButton };
